import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { gradientBorder, borderWidth } from "./Container.css.mjs";
const Container = ({
  children,
  borderRadius = "large",
  borderWidth: borderWidth$1 = "large",
  background = "surface",
  padding = "gutter",
  ...restProps
}) => /* @__PURE__ */ jsxs(
  Box,
  {
    position: "relative",
    borderRadius,
    background,
    padding,
    ...restProps,
    children: [
      /* @__PURE__ */ jsx(
        Box,
        {
          component: "span",
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          borderRadius,
          className: [gradientBorder, borderWidth[borderWidth$1]]
        }
      ),
      children
    ]
  }
);
export {
  Container
};
